module.exports = __webpack_public_path__ + "img/video-call.88315a7b.svg";